/**
 * Cloudinary URL transforms. Centralised so the story prefetcher (in
 * Activity.js StoriesRail) and the StoryViewer agree on the SAME URL — if
 * they diverge, the prefetch warms the CDN for a URL the viewer never asks
 * for, and the user still sees a 1–3s blank when opening the story.
 */
export function optimizeMediaUrl(url, kind) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('res.cloudinary.com')) return url;
  // Already transformed — leave as-is.
  if (/\/upload\/[a-z0-9_,]+\//.test(url)) return url;
  const transforms = kind === 'video'
    ? 'f_auto,q_auto,w_1080,c_limit'
    : 'f_auto,q_auto,w_1080,c_limit,dpr_auto';
  return url.replace('/upload/', `/upload/${transforms}/`);
}
